import React, { useState, useEffect, useRef } from 'react';
import { format } from 'date-fns';
import ButtonTooltip from '../../components/Inputs/ButtonTooltip';
import { FaDatabase, FaFolder, FaPencil, FaPix } from 'react-icons/fa6';
import { FaCalendarAlt, FaFileDownload, FaHistory, FaReceipt } from "react-icons/fa";
import { LiaReceiptSolid } from "react-icons/lia";
import { FaBoxOpen, FaTruck, FaTimes, FaCheckCircle, FaBoxes } from 'react-icons/fa';
import DetalhesPedido from '../../components/Modals/Clients/DetalhesPedido';
import ModalEditarPedido from '../../components/Modals/Pedido/EditarPedido';
import ModalEditarStatusPedido from '../../components/Modals/Pedido/ModalEditarStatusPedido';
import VisualizarPedido from '../../components/Modals/Pedido/VisualizarPedido';
import { GetDataUser } from '../../util/GetDataUser';
import { eTipoUsuario } from '../../enum/eTipoUsuario';
import TabelaCarregando from '../../components/ui/TabelaCarregando';
import AlterarDataEstimadaEntregaModal from '../../components/Modals/gestao/alterarDataEstimadaEntrega';
import { TbTruckDelivery } from "react-icons/tb";
import { BiSolidEdit } from "react-icons/bi";
import ModalEditarAllStatusPedido from '../../components/Modals/gestao/ModalEditarAllStatusPedido';
import { IoReload } from "react-icons/io5";
import ArquivoPedidoModal from '../arquivoPedido/ArquivoPedidoModal';
import ModalHistoricoStatusPedido from '../../components/Modals/gestao/ModalHistoricoPedido';
import ModalAreaPix from '../../components/Modals/gestao/ModalAreaPix';
import { FaPercentage } from "react-icons/fa";
import ModalPorcentagemComissao from '../../components/Modals/gestao/ModalPorcentagemComissao';
import LogPedidoModal from '../../components/Modals/Pedido/ModalLogPedido';
import { api } from '../../components/api/api';
import { Alert, AlertErro } from '../../util/Alertas';
function GestaoTable(props) {
    const user = GetDataUser();
    const modalLogPedido = useRef();
    const modalAreaPix = useRef();
    const modalComissao = useRef();
    const modalHistoricoStatusPedidoRef = useRef();
    const dataEstimadaEntregaModalRef = useRef();
    const arquivoPedidoModalRef = useRef();
    const allStatusRef = useRef();
    const [showEditarStatusModal, setShowEditarStatusModal] = useState(false);
    const [pedidoSelecionado, setPedidoSelecionado] = useState(null);
    const [statusPedidoIcon, setStatusPedidoIcon] = useState({});
    const [sortConfig, setSortConfig] = useState({ key: 'pedido_id', direction: 'desc' });
    const [usuarios, setUsuarios] = useState([]);

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    useEffect(() => {
        setStatusPedidoIcon(getStatusButtonProps());
    }, [pedidoSelecionado]);

    const handleShowEditarStatusModal = (pedido) => {
        setPedidoSelecionado(pedido);
        setShowEditarStatusModal(true);
    };

    const handleHideEditarStatusModal = () => {
        setShowEditarStatusModal(false);
        setPedidoSelecionado(null);
    };

    const handleEditarStatusPedido = (pedidoId, novoStatus) => {
        handleHideEditarStatusModal();
    };

    const getStatusButtonProps = (statusPedidoId) => {
        switch (statusPedidoId) {
            case 1:
                return { text: "Aberto", color: "btn btn-info", icon: <FaBoxOpen /> };
            case 2:
                return { text: "Separação", color: "btn btn-success", icon: <FaBoxes /> }
            case 3:
                return { text: "Despachado", color: "btn btn-warning", icon: <FaTruck /> };
            case 4:
                return { text: "Concluído", color: "btn btn-success", icon: <FaCheckCircle /> };
            case 5:
                return { text: "Cancelado", color: "btn btn-danger", icon: <FaTimes /> };
            default:
                return { text: "Desconhecido", color: "btn btn-secondary", icon: <FaPencil /> };
        }
    };

    const {
        pedidos,
        carregando = false,
        statusPedido,
        statusPagamento,
        produtos,
        ReloadPage,
        handleChangeLinhaSelecionada,
        linhasSelecionadas,
        setLinhasSelecionadas
    } = props;

    // PAGINAÇÃO
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [customItemsPerPage, setCustomItemsPerPage] = useState('');

    const totalPages = Math.ceil(props.pedidos.length / itemsPerPage);

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) setCurrentPage(page);
    };

    // Aplicar paginação nos pedidos
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedPedidos = pedidos.slice(startIndex, startIndex + itemsPerPage);

    const sortedPedidos = [...paginatedPedidos].sort((a, b) => {
        const { key, direction } = sortConfig;
        let aValue = a[key];
        let bValue = b[key];
        if (key.includes('data')) {
            aValue = new Date(aValue);
            bValue = new Date(bValue);
        }
        if (typeof aValue === 'string') {
            aValue = aValue.toLowerCase();
            bValue = bValue.toLowerCase();
        }
        if (aValue < bValue) return direction === 'asc' ? -1 : 1;
        if (aValue > bValue) return direction === 'asc' ? 1 : -1;
        return 0;
    });


    const getSortIcon = (key) => {
        if (sortConfig.key !== key) return null;
        return sortConfig.direction === 'asc' ? '▲' : '▼';
    };

    const BuscarTodosUsuarios = () => {
        api.get("Usuario/BuscarTodosUsuarios", res => {
            setUsuarios(res.data);
        }, err => {
            AlertErro(err, 'Houve um erro ao buscar os usuários')
        })
    }

    useEffect(() => {
        BuscarTodosUsuarios()
    }, [])

    const DownloadBoleto = (pedidoId) => {
        api.get(`api/DownloadBoleto/${pedidoId}`, res => {
            const byteCharacters = atob(res.data.arquivo);

            const byteNumbers = new Array(byteCharacters.length);

            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);

            const blob = new Blob([byteArray], {
                type: 'application/pdf'
            });

            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = res.data.nome;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            window.URL.revokeObjectURL(url);
        }, err => {
            AlertErro(err);
        });
    }

    return (
        <div className='row'>
            <ModalPorcentagemComissao ref={modalComissao} />
            <ModalAreaPix ref={modalAreaPix} />
            <ArquivoPedidoModal
                ref={arquivoPedidoModalRef}
            />
            <AlterarDataEstimadaEntregaModal
                ref={dataEstimadaEntregaModalRef}
                hadleReloadPage={ReloadPage}
            />
            <ModalEditarAllStatusPedido
                statusPedido={statusPedido}
                onReload={props.ReloadPage}
                ref={allStatusRef}
                setLinhasSelecionadas={setLinhasSelecionadas}
            />
            {linhasSelecionadas.length > 0 && <div className="col-md-12" style={{ marginTop: 20 }}>
                <div className="col-md-3">
                    <button onClick={e => allStatusRef.current.Open(linhasSelecionadas, statusPedido)} className='btn btn-success'><BiSolidEdit size={20} /> Atualizar Status</button>
                </div>
            </div>}
            <div className="col-md-12 tabela-responsiva">
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th><input onChange={e => handleChangeLinhaSelecionada(props.pedidos.map(x => x.pedido_id), true)} type='checkbox' /></th>
                            <th style={{ cursor: 'pointer' }} onClick={() => handleSort('pedido_id')}>N° Pedido {getSortIcon('pedido_id')}</th>
                            <th style={{ cursor: 'pointer' }} onClick={() => handleSort('nomeCliente')}>Nome Cliente {getSortIcon('nomeCliente')}</th>
                            <th style={{ cursor: 'pointer' }} onClick={() => handleSort('nomeVendedor')}>Nome Vendedor {getSortIcon('nomeVendedor')}</th>
                            <th style={{ cursor: 'pointer' }} onClick={() => handleSort('localidade')}>Localidade {getSortIcon('localidade')}</th>
                            <th style={{ cursor: 'pointer' }} onClick={() => handleSort('data_pedido')}>Data Do Pedido {getSortIcon('data_pedido')}</th>
                            <th style={{ cursor: 'pointer' }} onClick={() => handleSort('valor_total')}>Valor Total Pedidos (R$) {getSortIcon('valor_total')}</th>
                            <th style={{ cursor: 'pointer' }} onClick={() => handleSort('saldo_devedor')}>Saldo Devedor (R$) {getSortIcon('saldo_devedor')}</th>
                            <th>Status Pedido</th>
                            <th>Status Pagamento</th>
                            <th className="coluna-acoes">{linhasSelecionadas.length === 0 && 'Ações'}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedPedidos.map((produto, index) => (
                            <tr key={produto.pedido_id}>
                                <td data-label="Selecionar"><input checked={linhasSelecionadas.includes(produto.pedido_id)} onChange={e => handleChangeLinhaSelecionada(produto.pedido_id)} type='checkbox' /></td>
                                <td data-label="N° Pedido">{produto.pedido_id}</td>
                                <td data-label="Nome Cliente">{produto.nomeCliente}</td>
                                <td data-label="Nome Vendedor">{produto.nomeVendedor}</td>
                                <td data-label="Localidade">{produto.localidade}</td>
                                <td data-label="Data Do Pedido">{format(produto.data_pedido, "dd/MM/yyyy")}</td>
                                <td data-label="Valor Total Pedido (R$)">R$ {produto.valor_total.toFixed(2).replaceAll('.', ',')}</td>
                                <td data-label="Saldo Devedor (R$)">R$ {produto.saldo_devedor.toFixed(2).replaceAll('.', ',')}</td>
                                <td data-label="Status Pedido">{statusPedido.filter(x => x.status_pedido_id === produto.status_pedido_id)[0]?.nome}</td>
                                <td data-label="Status Pagamento">{statusPagamento.filter(x => x.status_pagamento_id === produto.status_pagamento_id)[0]?.nome}</td>
                                <td data-label="Ações" className="coluna-acoes">
                                    {linhasSelecionadas.length === 0 && <div className="acoes-tabela">
                                        {(produto.status_pedido_id == 4 || produto.status_pedido_id == 6) && <ButtonTooltip
                                            text="Refazer pedido"
                                            textButton={<IoReload size={20} color='#fff' />}
                                            className='btn btn-warning'
                                            top={true}
                                            onClick={() => props.onSubmitRefazerPedido(produto.pedido_id)}
                                        />}
                                        {produto.status_pagamento_id < 4 && <ButtonTooltip
                                            text="Alterar Data Estimada Entrega"
                                            textButton={<FaCalendarAlt size={20} color='#fff' />}
                                            className='btn btn-success'
                                            top={true}
                                            onClick={() => dataEstimadaEntregaModalRef.current.Open(produto.pedido_id, produto.data_estimada_entrega, produto.dias_entrega?.split('|'))}
                                        />}
                                        <VisualizarPedido Pedido={produto} produtos={produtos} historico={produto.produtos} />
                                        {/* <DetalhesPedido /> */}
                                        {user.TipoUsuario !== eTipoUsuario.Vendedor && <ModalEditarPedido usuarios={usuarios} reloadPage={ReloadPage} PedidoId={produto.pedido_id} Pedido={produto} Produtos={produtos} Historico={produto.produtos} />}
                                        {user.IsMaster && <ButtonTooltip
                                            text="Histórico de Recibo"
                                            textButton={<FaReceipt size={20} color='#fff' />}
                                            className='btn btn-danger'
                                            top={true}
                                            onClick={() => window.location.href = `/recibos?pedidoId=${produto.pedido_id}`}
                                        />}
                                        {(user.IsMaster && produto.saldo_devedor !== 0 && produto.status_pedido_id !== 5) &&
                                            <ButtonTooltip
                                                text={"Gerar Recibo"}
                                                textButton={<LiaReceiptSolid size={23} color='#fff' />}
                                                className='btn btn-primary'
                                                top={true}
                                                onClick={() => window.location.href = `/recibo?pedidoId=${produto.pedido_id}`}
                                            />
                                        }
                                        {user.IsMaster && <ButtonTooltip
                                            text={"Editar Status Pedido"}
                                            textButton={getStatusButtonProps(produto.status_pedido_id).icon}
                                            className={`btn ${getStatusButtonProps(produto.status_pedido_id).color}`}
                                            top={true}
                                            onClick={() => handleShowEditarStatusModal(produto)}
                                        />}
                                        {user.IsMaster && <ButtonTooltip
                                            text={"Ver Log Do Pedido"}
                                            textButton={<FaDatabase />}
                                            className={`btn btn-info`}
                                            top={true}
                                            onClick={() => modalLogPedido.current.OpenModal(produto.pedido_id)}
                                        />}
                                        <ButtonTooltip
                                            text={"Arquivos"}
                                            textButton={<FaFolder />}
                                            className={`btn btn-success`}
                                            top={true}
                                            onClick={() => arquivoPedidoModalRef.current.verFiles(produto.pedido_id)}
                                        />
                                        <ButtonTooltip
                                            text={"Histórico de status"}
                                            textButton={<FaHistory />}
                                            className={`btn btn-danger`}
                                            top={true}
                                            onClick={() => modalHistoricoStatusPedidoRef.current.openModal(produto.pedido_id)}
                                        />
                                        {produto.forma_pagamento == "Pix" && <ButtonTooltip
                                            text={"Área Pix"}
                                            textButton={<FaPix />}
                                            className={`btn btn-success`}
                                            top={true}
                                            onClick={() => modalAreaPix.current.openModal(produto.pedido_id)}
                                        />}
                                        {user.IsMaster && produto.forma_pagamento == "Boleto" && <ButtonTooltip
                                            text={"Baixar Boleto"}
                                            textButton={<FaFileDownload />}
                                            className={`btn btn-success`}
                                            top={true}
                                            onClick={() => DownloadBoleto(produto.pedido_id)}
                                        />}
                                        {user.IsMaster && <ButtonTooltip
                                            text={"Alterar percentual de comissão"}
                                            textButton={<FaPercentage />}
                                            className={`btn btn-secondary`}
                                            top={true}
                                            onClick={() => modalComissao.current.openModal(produto.pedido_id)}
                                        />}
                                    </div>}
                                </td>
                            </tr>
                        ))}
                        {carregando && <TabelaCarregando colunas={11} texto="Carregando pedidos..." />}
                        {!carregando && pedidos.length === 0 && <tr>
                            <td colSpan="11" className="tabela-vazia"><span>Não foi encontrado nenhum pedido...</span></td>
                        </tr>}
                    </tbody>
                </table>
            </div>
            {/* PAGINAÇÃO */}
            {props.pedidos.length > 0 && (
                <div className="col-md-12 d-flex flex-wrap justify-content-between align-items-center gap-3 mt-3">
                    <div className='d-flex flex-wrap justify-content-center align-items-center gap-2'>
                        <button className="btn btn-secondary me-2" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Anterior</button>
                        <span>Página </span>
                        <input
                            className='form-control'
                            type="number"
                            value={currentPage}
                            onChange={(e) => handlePageChange(Number(e.target.value))}
                            style={{ width: 60, textAlign: 'center' }}
                        />
                        <span> de {totalPages}</span>
                        <button className="btn btn-secondary ms-2" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Próximo</button>
                    </div>

                    <div>
                        <span>Itens por página: </span>
                        <select
                            value={itemsPerPage}
                            onChange={(e) => setItemsPerPage(Number(e.target.value))}
                            className="form-select d-inline-block"
                            style={{ width: 80 }}
                        >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>
                    </div>
                </div>
            )}

            <ModalHistoricoStatusPedido
                ref={modalHistoricoStatusPedidoRef}
            />
            {showEditarStatusModal && (
                <ModalEditarStatusPedido
                    pedido={pedidoSelecionado}
                    statusPedido={statusPedido}
                    onHide={handleHideEditarStatusModal}
                    onEdit={handleEditarStatusPedido}
                    onReload={props.ReloadPage}
                />
            )}
            <LogPedidoModal ref={modalLogPedido} />
        </div>
    );
}

export default GestaoTable;
